import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TimeSuggestions" */ './lazyIndex')
);

export const initializeTimeSuggestions = new LazyAction(
    lazyModule,
    m => m.initializeTimeSuggestions
);

export { refreshTimeSuggestions, setCalendarComponent } from './actions/publicActions';

export const TimeSuggestions = createLazyComponent(lazyModule, m => m.TimeSuggestions);

export { default as getTimeSuggestionsRequestState } from './selectors/getTimeSuggestionsRequestState';

export { default as getNumberOfTimeSuggestionsToDisplay } from './selectors/getNumberOfTimeSuggestionsToDisplay';

export { default as getLastFindMeetingTimesRequestDate } from './selectors/getLastFindMeetingTimesRequestDate';

export { default as getLastFindMeetingTimesRequestId } from './selectors/getLastFindMeetingTimesRequestId';

export type { TimeSuggestionsProps } from './components/TimeSuggestionsProps';
